export const STATIC_GET = 'STATIC_GET';
export const STATIC_UDPATE = 'STATIC_UDPATE';